import fetchAPI from '../fetchUtils';

const supportAPI = {
  create: async (body) => fetchAPI.postWithAuth('/send-support-message', body),
};

export default supportAPI;
